import { Box, Skeleton, Stack } from '@mui/material'
import { RfhColors } from '../../config/florimixColors'

type TransactionSkeletonProps = {
  striped?: boolean
}

export const TransactionSkeleton = ({
  striped = false,
}: TransactionSkeletonProps) => {
  return (
    <Stack
      sx={{
        gap: 1,
        padding: theme => theme.spacing(1, 2, 1, 2),
        backgroundColor: striped ? RfhColors.lightGrey : RfhColors.white,
      }}
    >
      <Box
        sx={{
          gap: 2,
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        <Skeleton variant='text' animation='wave' width={90} height={26} />
        <Skeleton variant='rounded' animation='wave' width={76} height={26} />
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Skeleton variant='text' animation='wave' width='60%' height={24} />
        <Skeleton variant='text' animation='wave' width={90} height={24} />
      </Box>
      <Skeleton variant='text' animation='wave' width={140} height={24} />
    </Stack>
  )
}
